export default {
    getGoing: {
        dataTrackId: 'get-going-button',
        dataTrackLinkname: 'kom i gang',
    },
    googleWalletInfoBanner: {
        dataTrackId: 'google-wallet-info-banner',
        dataTrackLinkname: 'google wallet',
    },
    stepByStep: {
        dataTrackId: 'step-by-step',
        dataTrackLinkname: 'steg for steg',
    },
    stepByStep1: {
        dataTrackId: 'step-by-step-1',
        dataTrackLinkname: 'åpne Google Play på en mobil',
    },
    stepByStep2: {
        dataTrackId: 'step-by-step-2',
        dataTrackLinkname: 'søk etter Google Wallet',
    },
    stepByStep3: {
        dataTrackId: 'step-by-step-3',
        dataTrackLinkname: 'last ned appen',
    },
    stepByStep4: {
        dataTrackId: 'step-by-step-4',
        dataTrackLinkname: 'personvern',
    },
    stepByStepPrivacyLink: {
        dataTrackId: 'step-by-step-privacy-link',
        dataTrackLinkname: 'personvernerklæringen',
    },
    addToGooglePay: {
        dataTrackId: 'add-to-google-pay',
        dataTrackLinkname: 'legg til google pay',
    },
    activationFormCancelButton: {
        dataTrackId: 'activation-form-cancel-button',
        dataTrackLinkname: 'avbryt',
    },
    pushProvisionSuccessCloseButton: {
        dataTrackId: 'push-provision-success-close-button',
        dataTrackLinkname: 'tilbake',
    },
    pushProvisionConfirmPermissionButton: {
        dataTrackId: 'push-provision-confirm-permission-button',
        dataTrackLinkname: 'bekreft',
    },
    pushProvisionCancelButton: {
        dataTrackId: 'push-provision-cancel-button',
        dataTrackLinkname: 'avbryt',
    },
};
